import { useState } from 'react';
import Cropper from 'react-easy-crop';
import { isEmpty } from 'lodash';

import withStateDispatch from '../redux/withStateDispatch';
import { getCroppedImg } from '../helpers/CanvasUtils';
import Modal from './Modal';

const ProfileCropper = ({ modal, onClick, onOutsideClick, image }) => {
  const [zoom, setZoom] = useState(1);
  const [aspect] = useState(1);
  const [cropSize, setCropSize] = useState({ x: 0, y: 0 });
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onCropChange = (cropSizeData) => {
    setCropSize(cropSizeData);
  };

  const onCropComplete = (croppedArea, croppedAreaPixelsData) => {
    setCroppedAreaPixels(croppedAreaPixelsData);
  };

  const onZoomChange = (zoomData) => {
    setZoom(zoomData);
  };

  const showCroppedImage = async () => {
    const croppedImageData = await getCroppedImg(image, croppedAreaPixels);
    const avatarImageData = croppedImageData;
    if (!isEmpty(avatarImageData.name)) {
      onClick(avatarImageData);
    }
  };

  return (
    <>
      <Modal
        modal={modal}
        customContentClassName="mt-[50%] max-w-screen-md rounded-[7px] p-5 transition-all"
        customContent={
          <div className="">
            <div className="relative h-64">
              <Cropper
                image={image}
                crop={cropSize}
                zoom={zoom}
                aspect={aspect}
                cropShape="round"
                onCropChange={onCropChange}
                onCropComplete={onCropComplete}
                onZoomChange={onZoomChange}
              />
            </div>
            <div>
              <div className="mt-3 text-center sm:mt-5">
                <h3 className="text-lg leading-6 font-medium border-indigo-600 text-indigo-600">
                  Align your mug
                </h3>
                <div className="mx-px mt-px px-3 pt-2 text-sm leading-5 text-gray-500">
                  Then share your avatar with the world
                </div>
              </div>
              <div className="text-center items-center justify-end p-4">
                <button
                  onClick={onOutsideClick}
                  type="button"
                  className="px-6 py-2.5 text-gray-500 rounded shadow-md">
                  Back
                </button>
                <button
                  onClick={showCroppedImage}
                  type="button"
                  className="px-6 py-2.5 bg-indigo-600 text-white rounded shadow-md ml-2">
                  Make Avatar
                </button>
              </div>
            </div>
          </div>
        }
      />
    </>
  );
};

export default withStateDispatch(ProfileCropper);
